import { VoyceFeedbackSoonContent } from "../search/content/VoyceFeedbackSoonContent"

export const FeedbackPage = () => {

    return (
        <div className="pt-3">
            <VoyceFeedbackSoonContent />
        </div>
    )
}